import CustomTabPanel from "components/Shared/CustomTabPanel";
import CustomTabs from "components/Shared/CustomTabs";
import RowsSkeleton from "components/Shared/Skeleton/RowsSkeleton";
import { useSearchParams } from "react-router-dom";
import { useDistrictDetailContext } from "contexts/LocationContexts/DistrictDetailContext";
import DistrictLinkedBranches from "./DistrictLinkedBranches";
import LinkedMunicipality from "./LinkedMunicipality";

export const DistrictDrtailTabs = () => {
  const [searchParams] = useSearchParams();

  const activeTab = searchParams.get("tab") || "branches";
  const { districtDetail, loadingDetail } = useDistrictDetailContext();

  const tabs = [
    {
      label: "Linked Municipalities",
      value: "municipalities",
    },
    {
      label: "Linked Branches",
      value: "branches",
    },
  ];
  return (
    <>
      <CustomTabs tabs={tabs} activeTab={activeTab} />

      {!loadingDetail ? (
        <>
          <CustomTabPanel activeTab={activeTab} value="municipalities">
            <LinkedMunicipality districtDetail={districtDetail} />
          </CustomTabPanel>

          <CustomTabPanel activeTab={activeTab} value="branches">
            <DistrictLinkedBranches districtDetail={districtDetail} />
          </CustomTabPanel>
        </>
      ) : (
        <RowsSkeleton />
      )}
    </>
  );
};

export default DistrictDrtailTabs;
